(function () {
  var DEBUG = true;
  var LOG_PREFIX = '[MSO]';

  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, [LOG_PREFIX].concat([].slice.call(arguments))); } catch (e) {}
  }
  function warn() {
    try { console.warn.apply(console, [LOG_PREFIX].concat([].slice.call(arguments))); } catch (e) {}
  }
  function err() {
    try { console.error.apply(console, [LOG_PREFIX].concat([].slice.call(arguments))); } catch (e) {}
  }

  function serializeFormArray(formEl) {
    var $ = window.jQuery || window.$;
    if ($ && typeof $(formEl).serializeArray === 'function') {
      return $(formEl).serializeArray();
    }
    var arr = [];
    try {
      var fd = new FormData(formEl);
      fd.forEach(function (value, key) {
        arr.push({ name: key, value: String(value) });
      });
    } catch (e) {}
    return arr;
  }

  function getThemeMoneyFormat() {
    return (
      (window.themeSettings && (window.themeSettings.money_format || window.themeSettings.moneyFormat)) ||
      (window.Theme && window.Theme.moneyFormat) ||
      (window.Theme && window.Theme.settings && (window.Theme.settings.moneyFormat || window.Theme.settings.money_format)) ||
      (window.Shopify && window.Shopify.money_format) ||
      null
    );
  }

  function getCartRedirectionSetting() {
    return !!(
      (window.themeSettings && (window.themeSettings.cart_redirection || window.themeSettings.cartRedirection)) ||
      (window.Theme && window.Theme.settings && window.Theme.settings.cartRedirection)
    );
  }

  function ensureEmpireFlyoutDOM() {
    var wrapper = document.querySelector('.atc-popup-wrapper');
    var template = document.querySelector('[data-templates] [data-atc-banner]');
    return { wrapper: wrapper, template: template, ok: !!(wrapper && template) };
  }

  function initOne(root) {
    if (!root || root.__msoInit) return;
    root.__msoInit = true;

    var sectionId = root.getAttribute('data-section-id') || '';
    log('Init sticky offer', sectionId, root);
/*
    var qtyInput = root.querySelector('[data-mso-qty]');
    var radios = root.querySelectorAll('[data-mso-radio]');
    var options = root.querySelectorAll('[data-mso-option]');
*/
    var form = root.querySelector('form');
    var atcButton = root.querySelector('.mso-atc');

    if (!form || !atcButton) {
      warn('Missing form or button in sticky offer', sectionId);
      return;
    }
/*
    function setActive(selectedVal) {
      options.forEach(function (opt, idx) {
        var r = radios[idx];
        if (!r) return;
        opt.classList.toggle('is-active', r.value === selectedVal);
      });
      if (qtyInput) qtyInput.value = selectedVal;
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        setActive(radio.value);
      });
    });

    var checked = root.querySelector('[data-mso-radio]:checked');
    setActive(checked ? checked.value : '1');
*/
    function applyBottomPadding() {
      if (window.matchMedia('(max-width: 749px)').matches) {
        document.body.style.paddingBottom = (root.offsetHeight + 8) + 'px';
      } else {
        document.body.style.paddingBottom = '';
      }
    }
    window.addEventListener('resize', applyBottomPadding);
    window.addEventListener('orientationchange', applyBottomPadding);
    applyBottomPadding();

    function setProcessing() {
      if (!atcButton || atcButton.classList.contains('processing')) return;
      atcButton.classList.add('processing');
    }
    function clearProcessing() {
      if (!atcButton) return;
      atcButton.classList.remove('processing');
    }

    function fallbackNativeSubmit() {
      try { form.submit(); } catch (e) {}
    }

    function handleSubmit(e) {
      e.preventDefault();
      e.stopPropagation();

      if (atcButton.classList.contains('processing')) return;
      setProcessing();

      // If Empire flyout class isn't global, we can't use it
      if (typeof window.AddToCartFlyout !== 'function') {
        warn('AddToCartFlyout is NOT global. Falling back to native submit.');
        clearProcessing();
        fallbackNativeSubmit();
        return;
      }

      // Empire flyout needs template + wrapper to render
      var flyoutDOM = ensureEmpireFlyoutDOM();
      log('Flyout prereqs', {
        hasAddToCartFlyout: true,
        wrapper: !!flyoutDOM.wrapper,
        template: !!flyoutDOM.template
      });

      if (!flyoutDOM.ok) {
        warn('Empire flyout markup missing on this page. No flyout can render here.');
        clearProcessing();
        fallbackNativeSubmit();
        return;
      }

      // Clean previous instance if we created one
      if (root._msoFlyout && typeof root._msoFlyout.unload === 'function') {
        try { root._msoFlyout.unload(); } catch (e) {}
      }

      var formDataArray = serializeFormArray(form);
      var optionsObj = {
        atcButton: atcButton,
        settings: {
          moneyFormat: getThemeMoneyFormat(),
          cartRedirection: getCartRedirectionSetting()
        }
      };

      try {
// Ensure we have ONE real wrapper in <body>
function ensureWrapper() {
  var existing = document.querySelector('.atc-popup-wrapper');
  if (existing && existing.parentElement === document.body) return existing;

  // If wrapper exists but not in body (PageFly/dom swaps), recreate it
  var wrapper = existing;
  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.className = 'atc-popup-wrapper';
  }

  // Ensure overlay exists
  var overlay = wrapper.querySelector('.popup-cart-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'popup-cart-overlay';
    overlay.innerHTML = '&nbsp;';
    wrapper.appendChild(overlay);
  }

  document.body.appendChild(wrapper);
  return wrapper;
}

root._msoFlyout = new window.AddToCartFlyout(formDataArray, optionsObj, {
  onError: function (e2) {
    warn('Flyout onError', e2);
    clearProcessing();
  },
  onSuccess: function () {
    log('Flyout onSuccess');
      const msoSubLabel = document.querySelector('.mso-subscription[data-mso-mode-panel] label');
      if(msoSubLabel && msoSubLabel.classList.contains("is-active")) {
        window.location.href = "/cart";
        return;
      }
    // --- FORCE MOUNT ---
    // Empire creates the real flyout element at: root._msoFlyout.flyOut
    // But on PageFly templates, their append sometimes fails.
    try {
      var wrapper = ensureWrapper();
      var overlay = wrapper.querySelector('.popup-cart-overlay');

      // If Empire instance has a flyOut node, move it to wrapper
      var flyOutNode = root._msoFlyout && root._msoFlyout.flyOut;

      // If it's not present, fall back to cloning the template ourselves
      if (!flyOutNode) {
        var template = document.querySelector('[data-templates] [data-atc-banner]');
        if (template) {
          flyOutNode = template.cloneNode(true);
        }
      }

      if (flyOutNode) {
        // Remove any existing visible flyout
        wrapper.querySelectorAll('[data-atc-banner]').forEach(function(n){ n.remove(); });

        // Force attributes so Empire CSS + transitions consider it "open"
        flyOutNode.setAttribute('data-animation-state', 'open');
        flyOutNode.style.display = 'block';

        // Show overlay + wrapper
        wrapper.style.display = 'block';
        overlay && (overlay.style.display = 'block');

        // Add body open class (Empire uses this for scroll lock / styling)
        document.body.classList.add('atc-banner-open');

        wrapper.appendChild(flyOutNode);

        // Close button wiring (since we forced mount)
        var closeBtn = flyOutNode.querySelector('[data-atc-banner-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function() {
            wrapper.style.display = 'none';
            overlay && (overlay.style.display = 'none');
            document.body.classList.remove('atc-banner-open');
            flyOutNode.remove();
          }, { once: true });
        }

        // Click outside closes
        overlay && overlay.addEventListener('click', function() {
          wrapper.style.display = 'none';
          overlay.style.display = 'none';
          document.body.classList.remove('atc-banner-open');
          flyOutNode.remove();
        }, { once: true });
      } else {
        warn('No flyOut node found to mount.');
      }
    } catch (ex) {
      err('Force mount failed', ex);
    }

    clearProcessing();
  },
  onClose: function () {
    log('Flyout onClose');
    clearProcessing();
  }
});


      } catch (ex) {
        err('Failed to instantiate AddToCartFlyout', ex);
        clearProcessing();
        fallbackNativeSubmit();
      }
    }

    form.addEventListener('submit', handleSubmit);

    atcButton.addEventListener('click', function (e) {
      e.preventDefault();
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-mobile-sticky-offer]');
    log('Found sticky offer roots:', roots.length);
    roots.forEach(initOne);
  }

  // Run on normal pages
  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);

  // Run when Shopify sections re-render (theme editor / dynamic)
  document.addEventListener('shopify:section:load', initAll);

 
  



})();


(function () {
  function initStickyState(root) {
    if (!root || root.__msoStateInit) return;
    root.__msoStateInit = true;

    const stickyForm = root.querySelector('.mso-form');
    const qtyInput = root.querySelector('[data-mso-qty]');
    const sellingPlanInput = root.querySelector('[data-mso-selling-plan]');

    const topModeTriggers = root.querySelectorAll('[data-mso-mode-trigger]');
    const oneTimeTopTrigger = root.querySelector('[data-mso-mode-trigger="one-time"]');
    const subscriptionTopTrigger = root.querySelector('[data-mso-mode-trigger="subscription"]');

    const oneTimePanel = root.querySelector('[data-mso-mode-panel="one-time"]');
    const subscriptionPanel = root.querySelector('[data-mso-mode-panel="subscription"]');

    const oneTimeOptions = root.querySelectorAll('.mso-one-time [data-mso-option]');
    const subscriptionOption = root.querySelector('[data-mso-subscription-option]');
    const subscriptionRadio = root.querySelector('[data-mso-sub-radio]');
    const deliverySelect = root.querySelector('[data-mso-delivery-frequency]');
    const subscriptionPrice = root.querySelector('[data-mso-sub-price]');
    const mostCommonBadge = root.querySelector('.sub-most-common');

    let stickyMode = 'one-time';
    let appstleReady = false;
    let shouldAutoSelectMostCommon = false;

    function getAppstleWidget() {
      return document.querySelector('.appstle_sub_widget');
    }

    function getAppstleSubscriptionWrapper() {
      return document.querySelector('.appstle_subscription_wrapper_option.payAsYouGoPlansDropdownWrapper');
    }

    function getAppstleOneTimeWrapper() {
      return Array.from(document.querySelectorAll('.appstle_subscription_wrapper_option')).find(function (el) {
        return !!el.querySelector('.appstle_one_time_details_wrapper');
      }) || null;
    }

    function getAppstleSubscriptionRadio() {
      const wrapper = getAppstleSubscriptionWrapper();
      return wrapper ? wrapper.querySelector('input[type="radio"][name="selling_plan"]') : null;
    }

    function getAppstleOneTimeRadio() {
      const wrapper = getAppstleOneTimeWrapper();
      return wrapper ? wrapper.querySelector('input[type="radio"][name="selling_plan"]') : null;
    }

    function getAppstleSelect() {
      const wrapper = getAppstleSubscriptionWrapper();
      return wrapper ? wrapper.querySelector('.appstle_select') : null;
    }

    function getAppstleSubscriptionPriceText() {
      const wrapper = getAppstleSubscriptionWrapper();
      const priceEl = wrapper ? wrapper.querySelector('.appstle_subscription_amount') : null;
      return priceEl ? priceEl.textContent.trim() : '';
    }

    function getSelectedPackQty() {
      const checked = root.querySelector('[data-mso-radio]:checked');
      return checked ? parseInt(checked.value, 10) || 1 : 1;
    }

    function normalizeText(value) {
      return String(value || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function getVariantSelectorRoot() {
      return document.querySelector('[data-mso-variant-selector]');
    }

    function getActiveVariantId() {
      const stickyVariantInput = stickyForm ? stickyForm.querySelector('input[name="id"]') : null;
      if (stickyVariantInput && stickyVariantInput.value) {
        return String(stickyVariantInput.value);
      }

      const variantSelectorRoot = getVariantSelectorRoot();
      if (!variantSelectorRoot) return '';

      const activeOption = variantSelectorRoot.querySelector('[data-mso-option].is-active[data-variant-id]');
      return activeOption ? String(activeOption.getAttribute('data-variant-id')) : '';
    }

    function getExpectedMostCommonValueForActiveVariant() {
      if (!subscriptionPanel) return '';

      const subscriptionV1MostCommon = String(subscriptionPanel.getAttribute('data-v1-most-common') || '').trim();
      const subscriptionV2MostCommon = String(subscriptionPanel.getAttribute('data-v2-most-common') || '').trim();

      const variantSelectorRoot = getVariantSelectorRoot();

      // No custom variant selector present:
      // treat this as a single/default variant product and use v1-most-common only.
      if (!variantSelectorRoot) {
        return subscriptionV1MostCommon || '';
      }

      const activeVariantId = getActiveVariantId();
      if (!activeVariantId) return '';

      const selectorV1Id = String(variantSelectorRoot.getAttribute('data-v1-id') || '');
      const selectorV2Id = String(variantSelectorRoot.getAttribute('data-v2-id') || '');

      if (activeVariantId === selectorV1Id) {
        return subscriptionV2MostCommon;
      }

      if (activeVariantId === selectorV2Id) {
        return subscriptionV1MostCommon;
      }

      return '';
    }

    function selectMostCommonDeliveryOption() {
      if (!deliverySelect) return false;

      const expectedMostCommon = normalizeText(getExpectedMostCommonValueForActiveVariant());
      if (!expectedMostCommon) return false;

      const matchingOption = Array.from(deliverySelect.options).find(function (option) {
        if (!option.value) return false;
        return normalizeText(option.textContent) === expectedMostCommon;
      });

      if (!matchingOption) return false;

      deliverySelect.value = matchingOption.value;
      return true;
    }

    function updateMostCommonBadgeVisibility() {
      if (!mostCommonBadge || !deliverySelect) return;

      const expectedMostCommon = String(getExpectedMostCommonValueForActiveVariant() || '').trim();

      if (!expectedMostCommon) {
        mostCommonBadge.style.display = 'none';
        return;
      }

      const selectedOption = deliverySelect.options[deliverySelect.selectedIndex];
      const selectedText = selectedOption ? selectedOption.textContent : '';

      const shouldShow =
        normalizeText(expectedMostCommon) === normalizeText(selectedText);

      mostCommonBadge.style.display = shouldShow ? '' : 'none';
    }

    function setTopActive(mode) {
      topModeTriggers.forEach(function (trigger) {
        trigger.classList.toggle('is-active', trigger.getAttribute('data-mso-mode-trigger') === mode);
      });
    }

    function setPanelVisibility(mode) {
      if (oneTimePanel) {
        oneTimePanel.style.display = mode === 'one-time' ? '' : 'none';
      }
      if (subscriptionPanel) {
        subscriptionPanel.style.display = mode === 'subscription' ? '' : 'none';
      }
    }

    function syncQuantity() {
      if (!qtyInput) return;
      qtyInput.value = stickyMode === 'subscription' ? '1' : String(getSelectedPackQty());
    }

    function syncStickySellingPlanValue(value) {
      if (sellingPlanInput) {
        sellingPlanInput.value = value || '';
      }
    }

    function selectAppstleOneTime() {
      const radio = getAppstleOneTimeRadio();
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        radio.dispatchEvent(new Event('click', { bubbles: true }));
      }
      syncStickySellingPlanValue('');
    }

    function selectAppstleSubscriptionByPlanId(planId) {
      if (!planId) return;

      const radio = getAppstleSubscriptionRadio();
      const select = getAppstleSelect();

      if (select) {
        select.value = planId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        select.dispatchEvent(new Event('input', { bubbles: true }));
      }

      if (radio) {
        radio.checked = true;
        radio.value = planId;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        radio.dispatchEvent(new Event('click', { bubbles: true }));
      }

      syncStickySellingPlanValue(planId);
    }

    function syncRealPurchaseOption() {
      if (stickyMode === 'one-time') {
        selectAppstleOneTime();
        return;
      }

      if (stickyMode === 'subscription' && deliverySelect && appstleReady) {
        const planId = deliverySelect.value;
        selectAppstleSubscriptionByPlanId(planId);
        updateSubscriptionPriceFromSelectedOption();
        updateMostCommonBadgeVisibility();
      }
    }

    function clearOneTimeActive() {
      oneTimeOptions.forEach(function (option) {
        option.classList.remove('is-active');
        const radio = option.querySelector('[data-mso-radio]');
        if (radio) radio.checked = false;
      });
    }

    function setActiveOneTimePack(selectedLabel) {
      clearOneTimeActive();

      if (selectedLabel) {
        selectedLabel.classList.add('is-active');
        const radio = selectedLabel.querySelector('[data-mso-radio]');
        if (radio) radio.checked = true;
      }

      if (subscriptionOption) {
        subscriptionOption.classList.remove('is-active');
      }

      if (subscriptionRadio) {
        subscriptionRadio.checked = false;
      }

      stickyMode = 'one-time';
      setTopActive('one-time');
      setPanelVisibility('one-time');

      if (mostCommonBadge) {
        mostCommonBadge.style.display = 'none';
      }

      syncQuantity();
      syncRealPurchaseOption();
    }

    function setActiveSubscription() {
      clearOneTimeActive();

      if (subscriptionOption) {
        subscriptionOption.classList.add('is-active');
      }

      if (subscriptionRadio) {
        subscriptionRadio.checked = true;
      }

      stickyMode = 'subscription';
      setTopActive('subscription');
      setPanelVisibility('subscription');

      shouldAutoSelectMostCommon = true;
      refreshStickySubscriptionUI();

      syncQuantity();
      syncRealPurchaseOption();
    }

    function refreshStickySubscriptionUI() {
      populateDeliveryOptionsFromAppstle();
      updateSubscriptionPriceFromSelectedOption();
      updateMostCommonBadgeVisibility();
    }

    function updateSubscriptionPriceFromSelectedOption() {
      if (!deliverySelect || !subscriptionPrice) return;

      const liveAppstlePrice = getAppstleSubscriptionPriceText();
      const selectedOption = deliverySelect.options[deliverySelect.selectedIndex];

      if (liveAppstlePrice) {
        subscriptionPrice.textContent = liveAppstlePrice;

        if (selectedOption && selectedOption.value) {
          selectedOption.setAttribute('data-price-display', liveAppstlePrice);
        }
        return;
      }

      if (!selectedOption) return;
      subscriptionPrice.textContent = selectedOption.getAttribute('data-price-display') || '';
    }

    function populateDeliveryOptionsFromAppstle() {
      if (!deliverySelect) return;

      const appstleSelect = getAppstleSelect();
      const subscriptionPriceText = getAppstleSubscriptionPriceText();
      const previousValue = deliverySelect.value;

      deliverySelect.innerHTML = '<option value="">Choose delivery frequency</option>';

      if (!appstleSelect) {
        appstleReady = false;
        if (subscriptionPrice) subscriptionPrice.textContent = '';
        if (mostCommonBadge) mostCommonBadge.style.display = 'none';
        return;
      }

      Array.from(appstleSelect.options).forEach(function (sourceOption) {
        const option = document.createElement('option');
        option.value = sourceOption.value;
        option.textContent = sourceOption.textContent.trim();
        option.setAttribute('data-price-display', subscriptionPriceText || '');
        deliverySelect.appendChild(option);
      });

      var selectedMostCommon = false;

      if (stickyMode === 'subscription' && shouldAutoSelectMostCommon) {
        selectedMostCommon = selectMostCommonDeliveryOption();
      }

      if (!selectedMostCommon) {
        if (previousValue && deliverySelect.querySelector('option[value="' + previousValue + '"]')) {
          deliverySelect.value = previousValue;
        } else if (appstleSelect.value) {
          deliverySelect.value = appstleSelect.value;
        } else if (deliverySelect.options.length > 1) {
          deliverySelect.selectedIndex = 1;
        }
      }

      updateSubscriptionPriceFromSelectedOption();
      updateMostCommonBadgeVisibility();
      appstleReady = deliverySelect.options.length > 1;
      shouldAutoSelectMostCommon = false;
    }

    function attachStickyEvents() {
      oneTimeOptions.forEach(function (option) {
        option.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          setActiveOneTimePack(option);
        });
      });

      if (oneTimeTopTrigger) {
        oneTimeTopTrigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const currentActivePack =
            root.querySelector('.mso-one-time [data-mso-option].is-active') ||
            oneTimeOptions[0];

          setActiveOneTimePack(currentActivePack);
        });
      }

      if (subscriptionTopTrigger) {
        subscriptionTopTrigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          setActiveSubscription();
        });
      }

      if (subscriptionOption) {
        subscriptionOption.addEventListener('click', function (e) {
          if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION') return;
          e.preventDefault();
          e.stopPropagation();
          setActiveSubscription();
        });
      }

      if (deliverySelect) {
        deliverySelect.addEventListener('change', function () {
          if (stickyMode !== 'subscription') {
            stickyMode = 'subscription';
            setTopActive('subscription');
            setPanelVisibility('subscription');

            if (subscriptionOption) subscriptionOption.classList.add('is-active');
            if (subscriptionRadio) subscriptionRadio.checked = true;
          }

          updateSubscriptionPriceFromSelectedOption();
          updateMostCommonBadgeVisibility();
          syncRealPurchaseOption();
        });
      }

      if (stickyForm) {
        stickyForm.addEventListener('submit', function () {
          syncQuantity();
          syncRealPurchaseOption();
        });
      }
    }

    function initDefaultState() {
      setTopActive('one-time');
      setPanelVisibility('one-time');

      const activePack =
        root.querySelector('.mso-one-time [data-mso-option].is-active') ||
        oneTimeOptions[0];

      setActiveOneTimePack(activePack);
    }

    function watchAppstleWidget() {
      if (getAppstleWidget() && getAppstleSelect()) {
        populateDeliveryOptionsFromAppstle();
        return;
      }

      const observerTarget = document.body;
      const observer = new MutationObserver(function () {
        if (getAppstleWidget() && getAppstleSelect()) {
          observer.disconnect();
          populateDeliveryOptionsFromAppstle();
        }
      });

      observer.observe(observerTarget, {
        childList: true,
        subtree: true
      });
    }

    attachStickyEvents();
    initDefaultState();
    watchAppstleWidget();

    if (!root.__msoVariantChangedBound) {
      root.__msoVariantChangedBound = true;

      document.addEventListener('mso:variant-changed', function () {
        setTimeout(function () {
          if (stickyMode === 'subscription') {
            shouldAutoSelectMostCommon = true;
            refreshStickySubscriptionUI();
            syncRealPurchaseOption();
          } else {
            refreshStickySubscriptionUI();
            updateSubscriptionPriceFromSelectedOption();
            if (mostCommonBadge) mostCommonBadge.style.display = 'none';
            syncRealPurchaseOption();
          }
        }, 150);
      });
    }
  }

  function initAllStickyState() {
    document.querySelectorAll('[data-mobile-sticky-offer]').forEach(initStickyState);
  }

  document.addEventListener('DOMContentLoaded', initAllStickyState);
  window.addEventListener('load', initAllStickyState);
  document.addEventListener('shopify:section:load', initAllStickyState);
})();
